// Mirror of BizCombo_LAC TenantBootstrapVm — the anonymous, pre-login payload that tells the UI
// which tenant a subdomain maps to, which module databases back it (names only), and what the
// organization is licensed for. Connection strings never reach the browser.

export interface TenantBootstrap {
  tenantId: string;
  organizationId: string;
  organizationCode: string;
  organizationName: string;
  tenantStatus: TenantStatus;
  environment: string;
  modules: BootstrapModule[];
  entitlements: Entitlement;
}

export type TenantStatus = 'Active' | 'Suspended' | 'Archived';

export interface BootstrapModule {
  moduleCode: string;
  moduleName: string;
  databaseName: string;
  status: string;
}

export interface Entitlement {
  tenantId: string;
  planCode: string;
  licenseStatus: string;
  seatLimit: number;
  viewerLimit: number;
  modules: ModuleEntitlement[];
}

export interface ModuleEntitlement {
  moduleCode: string;
  moduleName: string;
  effectiveTier: string;
  features: FeatureEntitlement[];
}

export interface FeatureEntitlement {
  code: string;
  name: string;
  allowed: boolean;
  usageLimit?: number;
}

// Module codes as seeded in the Billing module (BizCombo_LAC DbInitializer).
export enum TenantModuleCode {
  Identity = 'IDENTITY',
  Corporate = 'CORPORATE',
  Invoicing = 'INVOICING',
}
